import { defineComponent as n } from "vue";
import r from "./td-longtail-vue-components19.js";
import { useLabeledInput as s } from "./td-longtail-vue-components258.js";
const c = /* @__PURE__ */ n({
  __name: "text-input",
  props: {
    label: { default: void 0 },
    labelClass: { default: void 0 },
    id: { default: void 0 },
    errorMessage: { default: void 0 },
    hintMessage: { default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    showLabel: { type: Boolean },
    large: { type: Boolean },
    medium: { type: Boolean },
    inlineLabel: { type: Boolean },
    hasFixedValue: { type: Boolean, default: !1 },
    idPrefix: { default: void 0 },
    placeholder: { default: void 0 },
    inputClass: { default: void 0 },
    maxlength: { default: void 0 },
    inputProps: { default: void 0 },
    autocomplete: { default: void 0 },
    value: { default: void 0 },
    minlength: { default: void 0 },
    type: { default: "text" }
  },
  emits: ["input", "focus"],
  setup(l, { expose: d, emit: e }) {
    const o = l, { inputWrapperProps: i, inputFieldProps: p, onInput: t, onFocus: u, focus: a } = s(
      o,
      e
    );
    return d({ focus: a, onInput: t }), { __sfc: !0, props: o, emits: e, inputWrapperProps: i, inputFieldProps: p, onInput: t, onFocus: u, focus: a, InputWrapper: r };
  }
});
export {
  c as default
};
